import * as ActionTypes from '../addPhotos';

const initialState = {
  galleries: [],
  galleryImages: {},
  selectedGallery: null,
};

const galleriesReducer = (state = initialState, action) => {
  let newState = { ...state };
  switch (action.type) {
    case ActionTypes.SET_GALLERIES:
      newState.galleries = action.galleries;
      return newState;
    case ActionTypes.SET_GALLERY_IMAGES:
      newState.galleryImages = { ...state.galleryImages };
      newState.galleryImages[action.pk] = action.images;
      return newState;
    case ActionTypes.SET_SELECTED_GALLERY:
      newState.selectedGallery = action.name;
      return newState;
    default:
      return state;
  }
};

export default galleriesReducer;
